const ChecklistIcon = ({ size = 140, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="70" cy="70" r="70" fill="#23A26D" fillOpacity="0.12" />
    <path
      d="M68.7493 36.6666C50.3827 36.6666 35.416 51.6333 35.416 70C35.416 88.3666 50.3827 103.333 68.7493 103.333C87.116 103.333 102.083 88.3666 102.083 70C102.083 51.6333 87.116 36.6666 68.7493 36.6666ZM84.6827 62.3333L65.7827 81.2333C65.316 81.7 64.6827 81.9666 64.016 81.9666C63.3493 81.9666 62.716 81.7 62.2493 81.2333L52.816 71.8C51.8493 70.8333 51.8493 69.2333 52.816 68.2666C53.7827 67.3 55.3827 67.3 56.3493 68.2666L64.016 75.9333L81.1493 58.8C82.116 57.8333 83.716 57.8333 84.6827 58.8C85.6493 59.7666 85.6493 61.3333 84.6827 62.3333Z"
      fill="#23A26D"
    />
  </svg>
);

export default ChecklistIcon;
